import React from "react";
import { Message } from "../../../types/conversations";
import { WizardMessageItem } from "./WizardMessageItem";
import { WizardStepId } from "./types";
import { LinkThreeData } from "../../../types";

interface WizardMessage extends Message {
  wizardType?: "question" | "confirmation" | "error" | "component" | "info";
  component?: React.ReactNode;
  actions?: Array<{
    label: string;
    onClick: () => void;
    variant?: "primary" | "secondary";
  }>;
}

interface WizardMessagesListProps {
  messages: WizardMessage[];
  messagesContainerRef: React.RefObject<HTMLDivElement>;
  messagesEndRef: React.RefObject<HTMLDivElement>;
  currentStep: WizardStepId;
  onImageUpload: (photoBase64: string | null) => void;
  profileData: LinkThreeData | null;
}

export const WizardMessagesList: React.FC<WizardMessagesListProps> = ({
  messages,
  messagesContainerRef,
  messagesEndRef,
  currentStep,
  onImageUpload,
  profileData,
}) => {
  return (
    <div
      ref={messagesContainerRef}
      className="conversations-scroll messages-list-optimized flex-1 min-h-0 overflow-y-auto px-3 py-3 space-y-2 md:px-4 md:py-4 md:space-y-3"
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg width='40' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h40v40H0z' fill='%23f0f0f0' fill-opacity='0.05'/%3E%3C/svg%3E\")",
        WebkitOverflowScrolling: "touch",
        overscrollBehavior: "contain",
      }}
    >
      {messages.length === 0 && (
        <div className="flex flex-col items-center justify-center h-full text-center p-6">
          <div className="w-16 h-16 mb-4 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center">
            <svg
              className="w-8 h-8 text-purple-600 dark:text-purple-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
              />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            Iniciando conversa...
          </h3>
          <p className="text-sm text-gray-500 dark:text-gray-400 max-w-xs">
            Aguarde um momento enquanto carregamos seu assistente virtual
          </p>
        </div>
      )}

      {messages.map((message, index) => {
        const prevTimestamp = messages[index - 1]?.timestamp;
        const currentTimestamp = message.timestamp;

        const prevDate =
          prevTimestamp instanceof Date
            ? prevTimestamp
            : new Date(prevTimestamp);
        const currentDate =
          currentTimestamp instanceof Date
            ? currentTimestamp
            : new Date(currentTimestamp);

        const showDate =
          index === 0 ||
          (!Number.isNaN(prevDate.getTime()) &&
            !Number.isNaN(currentDate.getTime()) &&
            prevDate.toDateString() !== currentDate.toDateString());

        return (
          <WizardMessageItem
            key={message.id}
            message={message}
            showDate={showDate}
            currentStep={currentStep}
            onImageUpload={onImageUpload}
            profileData={profileData}
          />
        );
      })}
      <div ref={messagesEndRef} />
    </div>
  );
};
